import {React, useState, useEffect} from 'react'
import AxiosURL from '../../ApiService/AxiosURL';
import Header from '../layout/Header'
import Sidebar from '../layout/Sidebar'
import Breadcrumb from './Breadcrumb'
import { Table } from 'semantic-ui-react';

export default function MillList() {

    let milluserApi = "/farmers/mill_list";
    const [getMillUser, setMillUser] = useState([]);
    const [getDeletemill, setDeleteMill] = useState([]);
    useEffect(()=>{
        fetchMillUser(milluserApi);
    },[]);
    
    const fetchMillUser = async(url)=>{
        try{
            const response = await AxiosURL.get(url);
            setMillUser(response.data);
            // console.log(response.data);
        }catch(error){
            console.log(error);
        }
    }
    function deleteHandle(id){
        // alert(id);
        const response = AxiosURL.get('/farmers/delete_mill'+id)
        window.location.reload();
        // setDeleteMill(response.data);
        // console.log(response.data);
    }
  return (
    <>
     <div className='wrapper card-body'>
    <Sidebar />
    <div className='main '>
      <Header />
      <main className='content card mt-2'>
      <div className='container-fluid p-0'>
{/* <Breadcrumb /><br /> */}
<section className='row '>
   <div className='row'>
    <div className='card'>
        <div className='card-body'>
            <table className='table table-striped'>
                <thead>
                    <tr className='millListHead'>
                        <th>S.No.</th>
                        <th>Mill Name</th>
                        <th>Contact person name</th>
                        <th>Mobile No.</th>
                        <th>Email</th>
                        <th>District</th>
                        <th>Village</th>
                        {/* <th>Action</th> */}
                    </tr>
                </thead>
                <tbody>
                    {
                        getMillUser>0 ||
                        getMillUser.map((item, index)=>{
                            return(
                                <tr className='millListData' >
                                    <td>{index+1}</td>
                                    {/* <td>{item.id}</td> */}
                                    <td>{item.mill_name}</td>
                                    <td>{item.name}</td>
                                    <td>{item.phone}</td>
                                    <td>{item.email}</td>
                                    <td>{item.district}</td>
                                    <td>{item.village}</td>
                                    {/* <td><button className='btn btn-danger' onClick={()=>deleteHandle(item.id)}>delete</button></td> */}
                                </tr>
                                )
                        })
                    }
                </tbody>
            </table>
        </div>
    </div>
   </div>
   </section>
   </div>
   </main>
   </div>
   </div>
    </>
  )
}
